/**
 * @generated SignedSource<<891bf27ed2d8f83543ebb1be85b57208>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventsScreenList_query$data = {
  readonly upcomingEvents: {
    readonly edges: ReadonlyArray<{
      readonly cursor: string;
    }>;
    readonly " $fragmentSpreads": FragmentRefs<"EventList_eventsConnection">;
  };
  readonly " $fragmentSpreads": FragmentRefs<"EventList_query">;
  readonly " $fragmentType": "EventsScreenList_query";
};
export type EventsScreenList_query$key = {
  readonly " $data"?: EventsScreenList_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventsScreenList_query">;
};

import EventsScreenListPaginationQuery_graphql from './EventsScreenListPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "upcomingEvents"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": EventsScreenListPaginationQuery_graphql
    }
  },
  "name": "EventsScreenList_query",
  "selections": [
    {
      "alias": "upcomingEvents",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "and": [
              {
                "not": {
                  "metadata": {
                    "containsKey": "meetupEventID"
                  }
                }
              },
              {
                "allowGlobalListing": {
                  "equalTo": true
                }
              }
            ]
          }
        },
        {
          "kind": "Literal",
          "name": "timeSelection",
          "value": "UPCOMING"
        }
      ],
      "concreteType": "EventsConnection",
      "kind": "LinkedField",
      "name": "__EventsScreenList_query_upcomingEvents_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EventsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Event",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EventList_eventsConnection"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "__EventsScreenList_query_upcomingEvents_connection(filter:{\"and\":[{\"not\":{\"metadata\":{\"containsKey\":\"meetupEventID\"}}},{\"allowGlobalListing\":{\"equalTo\":true}}]},timeSelection:\"UPCOMING\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventList_query"
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "68c90724d9eff827c624e32d6c519096";

export default node;
